import React from 'react'

export default function TelPhone() {
    return (
        <div>
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_252_2689)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M56.25 17.5C58.32 17.5 60 19.18 60 21.25V56.25C60 58.315 58.3225 60 56.25 60H38.75C36.6775 60 35 58.3125 35 56.25V21.25C35 19.1825 36.6825 17.5 38.75 17.5H56.25ZM33.9825 60H10L16.4975 52.5H32.5V57.01C32.5 58.4575 33.34 59.735 33.9825 60ZM47.5 57.5C46.1175 57.5 45 56.38 45 55C45 53.62 46.1175 52.5 47.5 52.5C48.88 52.5 49.9975 53.62 49.9975 55C49.9975 56.38 48.88 57.5 47.5 57.5ZM57.5 50V24.94H37.5V50H57.5ZM55 15H50V5H5V42.5H32.5V47.5H0V0H55V15ZM48.75 22.5C49.4375 22.5 50 21.94 50 21.25C50 20.56 49.4375 20 48.75 20H46.25C45.56 20 45 20.56 45 21.25C45 21.94 45.56 22.5 46.25 22.5H48.75Z" fill="#BB0600" />
                </g>
                <defs>
                    <clipPath id="clip0_252_2689">
                        <rect width="60" height="60" fill="white" />
                    </clipPath>
                </defs>
            </svg>

        </div>
    )
}
